var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMenuStarHalfFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.47 6.396a.548.548 0 00-.445-.37l-3.875-.53-1.65-3.67A.547.547 0 008 1.5v10.983l3.385 1.945a.548.548 0 00.59-.03.554.554 0 00.225-.545l-.715-4.041 2.855-2.85a.56.56 0 00.13-.566z",
    fill: "#CCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.998 1.5a.547.547 0 00-.5.325L5.848 5.49l-3.875.535a.55.55 0 00-.31.935l2.855 2.85-.72 4.045c-.04.21.05.42.225.545a.548.548 0 00.59.03l3.385-1.95V1.5z",
    fill: "#F59600"
  })));
}

export default SvgIconMenuStarHalfFilled;